import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { CustomUtilityAccountsComponent } from './pages/custom-utility-accounts/custom-utility-accounts.component';
import { CustomConsumptionUploadComponent } from './pages/custom-consumption-upload/custom-consumption-upload.component';
import { CustomFileValidationComponent } from './pages/custom-file-validation/custom-file-validation.component';
import { CustomSupplyDetailsComponent } from './pages/custom-supply-details/custom-supply-details.component';
import { CustomGetQuoteComponent } from './pages/custom-get-quote/custom-get-quote.component';
import { CustomYoureDoneComponent } from './pages/custom-youre-done/custom-youre-done.component';
import { MaterialModule } from '../app.material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WizardBarModule } from '../wizard-bar/wizard-bar.module';
import { WizardStepCol, WizardValidationService } from '../wizard-bar/services/wizard.service';
import { CustomConstants } from './models/custom-constants';
import { CustomService } from './services/custom.service';
import { FileManagementModule } from '../filemanagement/file-management.module';
import { FixDataComponent } from './components/fix-data/fix-data-component';
import { QuotingModule } from '../quoting/quoting.module';
import { CustomRoutingModule } from './custom-routing.module';
import { CustomContractDetailsComponent } from './pages/custom-contract-details/custom-contract-details.component';
import { CustomCustomerDetailsComponent } from './pages/custom-customer-details/custom-customer-details.component';

@NgModule({
  declarations: [
    CustomUtilityAccountsComponent,
    CustomConsumptionUploadComponent,
    CustomFileValidationComponent,
    CustomSupplyDetailsComponent,
    CustomGetQuoteComponent,
    CustomYoureDoneComponent,
    FixDataComponent,
    CustomContractDetailsComponent,
    CustomCustomerDetailsComponent,
    ],
  exports: [
    CustomUtilityAccountsComponent,
    CustomConsumptionUploadComponent,
    CustomFileValidationComponent,
    CustomSupplyDetailsComponent,
    CustomGetQuoteComponent,
    CustomYoureDoneComponent,
    FixDataComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    InlineSVGModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    WizardBarModule,
    FileManagementModule,
    QuotingModule,
    CustomRoutingModule
  ],
  providers: [CustomService,
    { provide: WizardStepCol, useValue: { steps: CustomConstants.wizardSteps } as WizardStepCol },
    { provide: WizardValidationService, useClass: CustomService },
  ]
})
export class CustomModule { }
